import {Injectable, Provider} from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpHeaders,
  HTTP_INTERCEPTORS,
  HttpEvent, HttpHandlerFn
} from '@angular/common/http';
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const token = localStorage.getItem('access_token');
    if (request.url.startsWith(environment.apiUrl) && token) {
      const headers = new HttpHeaders().append("Authorization", `Bearer ${token}`);
      const modifiedRequest = request.clone({headers});
      return next.handle(modifiedRequest);
    }
    return next.handle(request);
  }
}


export function tokenInterceptor(request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const token = localStorage.getItem('access_token');
  if (request.url.startsWith(environment.apiUrl) && token) {
    const headers = new HttpHeaders().append("Authorization", `Bearer ${token}`);
    const modifiedRequest = request.clone({headers});
    return next(modifiedRequest);
  }
  return next(request);
}
